import React from 'react';

import {
    Title,
    Header,
    HeaderText
} from './landing-title.styled';

type LandingTitleProps = {
    title: string
};

/**
 * Displays title on landing routes.
 */
export const LandingTitle = ({ title }: LandingTitleProps) => {
    return (
        <Title>
            <Header>
                <HeaderText>
                    {title}
                </HeaderText>
            </Header>
        </Title>
    );
};
